/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const WorkRubricItemParser = /* #__PURE__ */ parsers.object([
    ['itemId', codecNumber, 'item_id'],
    ['multiplier', codecNumber],
    ['achievedPoints', codecNumber, 'achieved_points'],
]);
export class WorkRubricItem extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return WorkRubricItemParser.decode(input).map(res => new WorkRubricItem(res));
    }
    static unsafeDecode(input) {
        return WorkRubricItem.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return WorkRubricItemParser.encode(data);
    }
    static schema() {
        return WorkRubricItemParser.schema();
    }
}
